/**
 * City metadata for Georgian city landing pages.
 * Used for: SEO text generation, URL validation, sitemap generation.
 *
 * slug   — URL segment (/search/car/tbilisi)
 * ge/ru/en/uk — translated city name for display and SEO
 * priority — sitemap priority (higher = more important)
 */
export const CITY_META = {
    tbilisi: {
        ge: 'თბილისი',
        ru: 'Тбилиси',
        en: 'Tbilisi',
        uk: 'Тбілісі',
        priority: '0.9',
    },
    batumi: {
        ge: 'ბათუმი',
        ru: 'Батуми',
        en: 'Batumi',
        uk: 'Батумі',
        priority: '0.85',
    },
    kutaisi: {
        ge: 'ქუთაისი',
        ru: 'Кутаиси',
        en: 'Kutaisi',
        uk: 'Кутаїсі',
        priority: '0.8',
    },
    rustavi: {
        ge: 'რუსთავი',
        ru: 'Рустави',
        en: 'Rustavi',
        uk: 'Руставі',
        priority: '0.75',
    },
    gori: {
        ge: 'გორი',
        ru: 'Гори',
        en: 'Gori',
        uk: 'Горі',
        priority: '0.7',
    },
    zugdidi: {
        ge: 'ზუგდიდი',
        ru: 'Зугдиди',
        en: 'Zugdidi',
        uk: 'Зугдіді',
        priority: '0.7',
    },
    poti: {
        ge: 'ფოთი',
        ru: 'Поти',
        en: 'Poti',
        uk: 'Поті',
        priority: '0.65',
    },
    telavi: {
        ge: 'თელავი',
        ru: 'Телави',
        en: 'Telavi',
        uk: 'Телаві',
        priority: '0.65',
    },
    marneuli: {
        ge: 'მარნეული',
        ru: 'Марнеули',
        en: 'Marneuli',
        uk: 'Марнеулі',
        priority: '0.65',
        dbKey: 'marneyli',
    },
    mtskheta: {
        ge: 'მცხეთა',
        ru: 'Мцхета',
        en: 'Mtskheta',
        uk: 'Мцхета',
        priority: '0.6',
    },
    borjomi: {
        ge: 'ბორჯომი',
        ru: 'Боржоми',
        en: 'Borjomi',
        uk: 'Боржомі',
        priority: '0.6',
    },
    akhaltsikhe: {
        ge: 'ახალციხე',
        ru: 'Ахалцихе',
        en: 'Akhaltsikhe',
        uk: 'Ахалціхе',
        priority: '0.6',
        dbKey: 'achalciche',
    },
    kobuleti: {
        ge: 'ქობულეთი',
        ru: 'Кобулети',
        en: 'Kobuleti',
        uk: 'Кобулеті',
        priority: '0.6',
    },
    signagi: {
        ge: 'სიღნაღი',
        ru: 'Сигнахи',
        en: 'Signagi',
        uk: 'Сигнагі',
        priority: '0.55',
        dbKey: 'signachis',
    },
    gurjaani: {
        ge: 'გურჯაანი',
        ru: 'Гурджаани',
        en: 'Gurjaani',
        uk: 'Гурджаані',
        priority: '0.55',
        dbKey: 'gyrdgani',
    },
    khashuri: {
        ge: 'ხაშური',
        ru: 'Хашури',
        en: 'Khashuri',
        uk: 'Хашурі',
        priority: '0.55',
        dbKey: 'chasuri',
    },
    senaki: {
        ge: 'სენაკი',
        ru: 'Сенаки',
        en: 'Senaki',
        uk: 'Сенакі',
        priority: '0.5',
    },
    zestafoni: {
        ge: 'ზესტაფონი',
        ru: 'Зестафони',
        en: 'Zestafoni',
        uk: 'Зестафоні',
        priority: '0.5',
    },
    ozurgeti: {
        ge: 'ოზურგეთი',
        ru: 'Озургети',
        en: 'Ozurgeti',
        uk: 'Озургеті',
        priority: '0.5',
    },
    kaspi: {
        ge: 'კასპი',
        ru: 'Каспи',
        en: 'Kaspi',
        uk: 'Каспі',
        priority: '0.5',
    },
    chiatura: {
        ge: 'ჭიათურა',
        ru: 'Чиатура',
        en: 'Chiatura',
        uk: 'Чіатура',
        priority: '0.5',
    },
    tsqaltubo: {
        ge: 'წყალტუბო',
        ru: 'Цхалтубо',
        en: 'Tsqaltubo',
        uk: 'Цхалтубо',
        priority: '0.5',
        dbKey: 'chaltybo',
    },
    sagarejo: {
        ge: 'საგარეჯო',
        ru: 'Сагареджо',
        en: 'Sagarejo',
        uk: 'Сагареджо',
        priority: '0.5',
        dbKey: 'sagaredgo',
    },
    gardabani: {
        ge: 'გარდაბანი',
        ru: 'Гардабани',
        en: 'Gardabani',
        uk: 'Гардабані',
        priority: '0.5',
    },
    tkibuli: {
        ge: 'ტყიბული',
        ru: 'Ткибули',
        en: 'Tkibuli',
        uk: 'Ткібулі',
        priority: '0.45',
        dbKey: 'tkibyli',
    },
    khoni: {
        ge: 'ხონი',
        ru: 'Хони',
        en: 'Khoni',
        uk: 'Хоні',
        priority: '0.45',
        dbKey: 'choni',
    },
    bolnisi: {
        ge: 'ბოლნისი',
        ru: 'Болниси',
        en: 'Bolnisi',
        uk: 'Болнісі',
        priority: '0.5',
    },
    akhalkalaki: {
        ge: 'ახალქალაქი',
        ru: 'Ахалкалаки',
        en: 'Akhalkalaki',
        uk: 'Ахалкалакі',
        priority: '0.5',
        dbKey: 'achalkalaki',
    },
    qvareli: {
        ge: 'ყვარელი',
        ru: 'Кварели',
        en: 'Qvareli',
        uk: 'Кварелі',
        priority: '0.45',
        dbKey: 'kvareli',
    },
    akhmeta: {
        ge: 'ახმეტა',
        ru: 'Ахмета',
        en: 'Akhmeta',
        uk: 'Ахмета',
        priority: '0.45',
        dbKey: 'achmeta',
    },
    kareli: {
        ge: 'კარელი',
        ru: 'Карели',
        en: 'Kareli',
        uk: 'Карелі',
        priority: '0.45',
    },
    lanchkhuti: {
        ge: 'ლანჩხუთი',
        ru: 'Ланчхути',
        en: 'Lanchkhuti',
        uk: 'Ланчхуті',
        priority: '0.45',
        dbKey: 'lanchyti',
    },
    dedoplistsqaro: {
        ge: 'დედოფლისწყარო',
        ru: 'Дедоплисцкаро',
        en: 'Dedoplistsqaro',
        uk: 'Дедоплісцкаро',
        priority: '0.4',
        dbKey: 'dedoplis',
    },
    lagodekhi: {
        ge: 'ლაგოდეხი',
        ru: 'Лагодехи',
        en: 'Lagodekhi',
        uk: 'Лагодехі',
        priority: '0.45',
        dbKey: 'lagodexi',
    },
    ninotsminda: {
        ge: 'ნინოწმინდა',
        ru: 'Ниноцминда',
        en: 'Ninotsminda',
        uk: 'Ніноцмінда',
        priority: '0.45',
        dbKey: 'nino',
    },
    abasha: {
        ge: 'აბაშა',
        ru: 'Абаша',
        en: 'Abasha',
        uk: 'Абаша',
        priority: '0.4',
    },
    tsnori: {
        ge: 'წნორი',
        ru: 'Цнори',
        en: 'Tsnori',
        uk: 'Цнорі',
        priority: '0.4',
        dbKey: 'cnori',
    },
    jvari: {
        ge: 'ჯვარი',
        ru: 'Джвари',
        en: 'Jvari',
        uk: 'Джварі',
        priority: '0.4',
        dbKey: 'dgavari',
    },
    sachkhere: {
        ge: 'საჩხერე',
        ru: 'Сачхере',
        en: 'Sachkhere',
        uk: 'Сачхере',
        priority: '0.45',
        dbKey: 'sachere',
    },
    dusheti: {
        ge: 'დუშეთი',
        ru: 'Душети',
        en: 'Dusheti',
        uk: 'Душеті',
        priority: '0.45',
    },
    tsalenjikha: {
        ge: 'წალენჯიხა',
        ru: 'Цаленджиха',
        en: 'Tsalenjikha',
        uk: 'Цаленджиха',
        priority: '0.4',
        dbKey: 'calendjicha',
    },
    vani: {
        ge: 'ვანი',
        ru: 'Вани',
        en: 'Vani',
        uk: 'Вані',
        priority: '0.4',
    },
    baghdati: {
        ge: 'ბაღდათი',
        ru: 'Багдати',
        en: 'Baghdati',
        uk: 'Багдаті',
        priority: '0.4',
    },
    vale: {
        ge: 'ვალე',
        ru: 'Вале',
        en: 'Vale',
        uk: 'Вале',
        priority: '0.4',
    },
    tetritskaro: {
        ge: 'თეთრიწყარო',
        ru: 'Тетрицкаро',
        en: 'Tetritskaro',
        uk: 'Тетріцкаро',
        priority: '0.4',
        dbKey: 'tetri',
    },
};

/** Lookup by URL slug. Returns null if city is unknown. */
export const getCityMeta = (slug) => CITY_META[slug] ?? null;

/** All city slugs available for landing pages. */
export const CITY_SLUGS = Object.keys(CITY_META);

const CITY_SLUG_BY_DB_KEY = Object.fromEntries(
    Object.entries(CITY_META)
        .filter(([, meta]) => meta.dbKey)
        .map(([slug, meta]) => [meta.dbKey, slug]),
);

export const getCityDbKey = (slug) => CITY_META[slug]?.dbKey ?? slug;

export const getCitySlug = (dbKey) => CITY_SLUG_BY_DB_KEY[dbKey] ?? dbKey;

export const getCityFilter = (slug) =>
    CITY_META[slug] ? { city: [getCityDbKey(slug)] } : null;
